var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle128(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4.003467243540269 353.5885967533749 12.119376777826162 12.191749113877734",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.11,359.42c.09,1.24-.86,2.34-2.03,2.36-1,.02-1.94-.83-2.07-1.87-.14-1.18.83-2.27,2.05-2.32,1.06-.04,1.97.78,2.05,1.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle128);
export default __webpack_public_path__ + "static/media/twinkle-1-28.1502210e0187f114d9194f17e134679c.svg";
export { ForwardRef as ReactComponent };